<template>
  <div class="page-rnr-field-wrap">
    <slot />
    <div class="page-rnr-field-error">
      <div v-if="error" class="page-rnr-field-error-message">{{ errorMessage }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorWrap',
  props: {
    // 是否需要展示错误
    error: {
      type: Boolean,
      default: false
    },
    // 错误展示值
    errorMessage: {
      type: String,
      default: '请输入内容'
    }
  }
}
</script>

<style lang="scss" scoped>
.page-rnr-field-wrap {
  .page-rnr-field-error {
    .page-rnr-field-error-message {
      color: #FF4C4F;
      font-size: 20px;
      font-weight: 400;
      height: 50px;
      padding-top: 12px;
      position: relative;

      &:after {
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        right: 0;
        top: -1px;
        left: 0;
        border-bottom: 1PX solid #ee0a24;
        transform: scaleY(0.5);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ErrorWrap.vue